export const LorenColor = [
    {
        priority: 0,
        name: 'light-blue',
        hexCode: '#ED1968'
    },
    {
        priority: 1,
        name: 'light-yellow',
        hexCode: '#F8971D'
    },
    {
        priority: 2,
        name: 'light-pink',
        hexCode: '#F7EC13'
    },
    {
        priority: 3,
        name: 'light-green',
        hexCode: '#90C73E'
    },
    {
        priority: 4,
        name: 'light-orange',
        hexCode: '#76C3ED'
    },
    {
        priority: 5,
        name: 'light-cyan',
        hexCode: '#ef0300'
    },
    {
        priority: 6,
        name: 'black',
        hexCode: '#000000'
    },
    {
        priority: 7,
        name: 'grey',
        hexCode: '#939393'
    },
    {
        priority: 8,
        name: 'navy',
        hexCode: '#9A6324'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#469990'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#800080'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#ffc0cb'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#ffa500'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#808000'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#000080'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#800000'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#ff00ff'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#00ff00'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#ffffe0'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#ffb6c1'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#d3d3d3'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#90ee90'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#e0ffff'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#add8e6'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#f0e68c'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#4b0082'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#008000'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#ffd700'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#ff00ff'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#9400d3'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#e9967a'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#8b0000'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#9932cc'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#ff8c00'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#556b2f'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#8b008b'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#bdb76b'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#006400'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#a9a9a9'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#00008b'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#00ffff'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#a52a2a'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#0000ff'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#000000'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#f5f5dc'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#f0ffff'
    },
    {
        priority: 9,
        name: 'teal',
        hexCode: '#00ffff'
    },
];
